module.exports = __webpack_public_path__ + "assets/5ccf881684821821bff26821ff60badc.jpg";